// Simple Google Analytics tracking for key user events

// Sign-up events
export function trackSignUpViewed() {
  if (typeof window !== "undefined" && (window as any).gtag) {
    (window as any).gtag("event", "sign_up_viewed", {
      event_category: "engagement",
      event_label: "Sign Up Form Viewed",
    });
  }
}

export function trackSignUpCompleted() {
  if (typeof window !== "undefined" && (window as any).gtag) {
    (window as any).gtag("event", "sign_up_completed", {
      event_category: "conversion",
      event_label: "Sign Up Completed Successfully",
    });
  }
}

// Login events
export function trackLoginSuccess() {
  if (typeof window !== "undefined" && (window as any).gtag) {
    (window as any).gtag("event", "login_success", {
      event_category: "engagement",
      event_label: "User Logged In Successfully",
    });
  }
}

// Email verification events
export function trackEmailVerified() {
  if (typeof window !== "undefined" && (window as any).gtag) {
    (window as any).gtag("event", "email_verified", {
      event_category: "conversion",
      event_label: "Email Verified Successfully",
    });
  }
}

// Dashboard events
export function trackDashboardViewed() {
  if (typeof window !== "undefined" && (window as any).gtag) {
    (window as any).gtag("event", "dashboard_viewed", {
      event_category: "engagement",
      event_label: "Dashboard Page Viewed",
    });
  }
}

// Sidebar navigation events
export function trackSidebarNavigation(itemTitle: string, itemPath: string) {
  if (typeof window !== "undefined" && (window as any).gtag) {
    (window as any).gtag("event", "sidebar_navigation", {
      event_category: "navigation",
      event_label: itemTitle,
      page_path: itemPath,
    });
  }
}
